import React, { useEffect, useMemo, useState } from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import MarketSVG from "./icons/market.svg";
import MyTradesSVG from "./icons/my_trades.svg";
import MyOrdersSVG from "./icons/my_orders.svg";
import { Tabs } from "antd";
import { SpvsTab } from "../../tabs/SpvsTab";
import { MyTradesTab } from "../../tabs/MyTradesTab";
import { MyOrdersTab } from "../../tabs/MyOrdersTab";

const getTabs = (userSignedIn: boolean) => {
  const rootTabs = [
    {
      label: (
        <Link to="spvs">
          <div className="flex items-center gap-2">
            <MarketSVG /> <span>Market</span>
          </div>
        </Link>
      ),
      key: "spvs",
      children: <SpvsTab />,
    },
  ];

  const signedInTabs = [
    {
      label: (
        <Link to="my_trades">
          <div className="flex items-center gap-2">
            <MyTradesSVG /> <span>My Trades</span>
          </div>
        </Link>
      ),
      key: "my_trades",
      children: <MyTradesTab />,
    },
    {
      label: (
        <Link to="my_orders">
          <div className="flex items-center gap-2">
            <MyOrdersSVG /> <span>My Orders</span>
          </div>
        </Link>
      ),
      key: "my_orders",
      children: <MyOrdersTab />,
    },
  ];

  return userSignedIn ? [...rootTabs, ...signedInTabs] : rootTabs;
};

type TabsSectionProps = {
  match: RouteComponentProps<{ subpage: string }>["match"];
  history: RouteComponentProps<{}>["history"];
  userSignedIn: boolean;
};

export const TabsSection = ({
  match,
  history,
  userSignedIn,
}: TabsSectionProps) => {
  const [activeTab, setActiveTab] = useState("market");

  const tabs = useMemo(() => getTabs(userSignedIn), [userSignedIn]);

  useEffect(() => {
    if (match.path.includes("/market")) {
      const validTabKeys = tabs.map((t) => t.key);
      const currentSubpage = match.params.subpage;

      const baseUrl = match.url.replace(/\/[^/]*$/, "");

      if (!currentSubpage || !validTabKeys.includes(currentSubpage)) {
        history.replace(`${baseUrl}/${tabs[0].key}`);
        setActiveTab(tabs[0].key);
      } else {
        setActiveTab(currentSubpage);
      }
    }
  }, [match.params.subpage, match.path, tabs]);

  return (
    <div>
      <Tabs
        defaultActiveKey={tabs[0].key}
        activeKey={activeTab}
        items={tabs}
        destroyInactiveTabPane
      />
    </div>
  );
};
